import { motion } from "framer-motion";
import { AUDIENCE } from "@/lib/data";
import { fadeUp, inViewOnce } from "@/lib/motion";

export default function Audience() {
  return (
    <section
      data-testid="audience-section"
      className="relative py-24 md:py-36 border-t border-[color:var(--line)]"
    >
      <div className="mx-auto max-w-[1360px] px-5 md:px-8">
        <div className="flex items-center justify-between mb-14 md:mb-20">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[color:var(--ink-3)]">
            Ch. 06 — Who
          </span>
          <span className="font-mono text-[11px] tabular-nums text-[color:var(--ink-3)]">
            §006 / 010
          </span>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={inViewOnce}
          transition={{ duration: 0.9 }}
          className="font-serif text-[38px] sm:text-[56px] md:text-[72px] leading-[0.98] tracking-[-0.03em] font-medium max-w-[1000px] text-balance"
        >
          Designed for professionals building{" "}
          <em className="italic font-normal text-[color:var(--copper-2)]">
            the future of finance.
          </em>
        </motion.h2>

        <motion.ul
          initial="hidden"
          whileInView="show"
          viewport={inViewOnce}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.05 } },
          }}
          className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-0 max-w-[1100px]"
        >
          {AUDIENCE.map((a, i) => (
            <motion.li
              key={a}
              variants={fadeUp}
              className="flex items-baseline gap-6 py-5 border-b border-[color:var(--line-strong)] group"
              data-testid={`audience-item-${i}`}
            >
              <span className="font-mono text-[10px] tabular-nums text-[color:var(--copper)] w-8">
                0{i + 1}
              </span>
              <span className="font-serif text-[22px] md:text-[24px] leading-[1.2] text-[color:var(--ink)] group-hover:tick-underline transition-all">
                {a}
              </span>
            </motion.li>
          ))}
        </motion.ul>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={inViewOnce}
          transition={{ duration: 0.9 }}
          className="mt-12 md:mt-16 max-w-[900px] border border-[color:var(--copper)] bg-[color:var(--copper-tint)] p-6 md:p-8 rounded-sm"
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[color:var(--copper-2)]">
            Alumni note
          </p>
          <p className="mt-3 font-serif text-[20px] md:text-[26px] leading-[1.35] text-[color:var(--ink)] italic">
            Completed a Packt GenAI for Finance program? This certification is
            your next step — from using generative AI tools to engineering
            complete agentic workflows.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
